var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_settings",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1665",
    "data-name": "Rectangle 1665",
    width: 34.125,
    height: 24.15,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1682",
    "data-name": "Rectangle 1682",
    width: 42,
    height: 42,
    fill: "#6639b7",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_settings-2",
    "data-name": "icon_settings",
    transform: "translate(3.938 9.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3704",
    "data-name": "Groupe 3704",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13538",
    "data-name": "Trac\\xE9 13538",
    d: "M18.478,7.912H16.542a7.122,7.122,0,0,0-.775-1.872l1.4-1.359a.87.87,0,0,0,.022-1.227l-.022-.022L15.918,2.183a.87.87,0,0,0-1.227-.022l-.022.022L13.3,3.561a7,7,0,0,0-1.872-.773V.866A.864.864,0,0,0,10.564,0H8.785a.866.866,0,0,0-.866.865V2.808a7.014,7.014,0,0,0-1.872.775l-1.366-1.4a.87.87,0,0,0-1.227-.022l-.022.022L2.184,3.432a.865.865,0,0,0-.026,1.223l0,0,.022.022L3.544,6.04a7.011,7.011,0,0,0-.774,1.872H.866A.867.867,0,0,0,0,8.778v1.783a.868.868,0,0,0,.866.869H2.808a7.023,7.023,0,0,0,.775,1.87l-1.4,1.364a.862.862,0,0,0-.027,1.219l.005.005.022.022,1.246,1.249a.87.87,0,0,0,1.227.022l.022-.022L6.042,15.8a7.11,7.11,0,0,0,1.87.775v1.92a.866.866,0,0,0,.865.866h1.776a.862.862,0,0,0,.866-.858V16.535a7.094,7.094,0,0,0,1.872-.775l1.366,1.4a.87.87,0,0,0,1.227.022l.022-.022,1.249-1.249a.87.87,0,0,0,.022-1.227l-.022-.022L15.794,13.3a7.074,7.074,0,0,0,.775-1.872h1.922a.87.87,0,0,0,.869-.866V8.788a.87.87,0,0,0-.861-.874h-.027Zm-8.8,4.88a3.119,3.119,0,0,1-3.119-3.12h0A3.118,3.118,0,0,1,9.672,6.552h0a3.12,3.12,0,1,1,0,6.24Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13539",
    "data-name": "Trac\\xE9 13539",
    d: "M272.634,5.541h-1.356a4.99,4.99,0,0,0-.543-1.311l.979-.952a.609.609,0,0,0,.015-.859l-.015-.015-.873-.875a.609.609,0,0,0-.859-.015l-.015.015-.961.966a4.9,4.9,0,0,0-1.311-.541V.607a.605.605,0,0,0-.6-.607h-1.246a.606.606,0,0,0-.607.606h0v1.36a4.913,4.913,0,0,0-1.311.543l-.957-.981a.609.609,0,0,0-.859-.015l-.015.015-.873.875a.606.606,0,0,0-.018.856l0,0,.015.015.952.952a4.907,4.907,0,0,0-.542,1.311H260.3a.607.607,0,0,0-.607.607V7.4A.608.608,0,0,0,260.3,8h1.36a4.925,4.925,0,0,0,.543,1.31l-.979.955a.6.6,0,0,0-.019.854l0,0,.015.015.873.875a.609.609,0,0,0,.859.015l.015-.015.954-.952a4.979,4.979,0,0,0,1.31.543v1.345a.606.606,0,0,0,.606.607h1.244a.6.6,0,0,0,.607-.6V11.581A4.972,4.972,0,0,0,269,11.038l.957.979a.609.609,0,0,0,.859.015l.015-.015.874-.875a.609.609,0,0,0,.015-.859l-.015-.015-.954-.952A4.955,4.955,0,0,0,271.3,8h1.346a.609.609,0,0,0,.608-.607V6.155a.609.609,0,0,0-.6-.612h-.019Zm-6.166,3.417a2.185,2.185,0,0,1-2.184-2.185h0a2.184,2.184,0,0,1,2.183-2.184h0a2.185,2.185,0,1,1,0,4.37Z",
    transform: "translate(-239.127 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13540",
    "data-name": "Trac\\xE9 13540",
    d: "M238.058,188.733h-.951a3.5,3.5,0,0,0-.381-.92l.687-.668a.427.427,0,0,0,.011-.6l-.011-.011-.612-.613a.427.427,0,0,0-.6-.011l-.011.011-.674.677a3.443,3.443,0,0,0-.92-.38v-.944a.424.424,0,0,0-.423-.426H233.3a.425.425,0,0,0-.426.425h0v.954a3.449,3.449,0,0,0-.92.381l-.671-.688a.427.427,0,0,0-.6-.011l-.011.011-.612.613a.425.425,0,0,0-.013.6l0,0,.011.011.668.668a3.442,3.442,0,0,0-.38.92h-.935a.426.426,0,0,0-.426.426v.876a.426.426,0,0,0,.426.427h.954a3.448,3.448,0,0,0,.381.919l-.687.67a.424.424,0,0,0-.013.6l0,0,.011.011.612.613a.427.427,0,0,0,.6.011l.011-.011.669-.668a3.5,3.5,0,0,0,.919.381v.943a.425.425,0,0,0,.425.426h.873a.424.424,0,0,0,.426-.422s0,0,0,0v-.964a3.485,3.485,0,0,0,.92-.381l.671.687a.427.427,0,0,0,.6.011l.011-.011.613-.613a.427.427,0,0,0,.011-.6l-.011-.011-.669-.668a3.475,3.475,0,0,0,.381-.92h.944a.427.427,0,0,0,.427-.426v-.872a.427.427,0,0,0-.423-.429h-.01Zm-4.325,2.4A1.532,1.532,0,0,1,232.2,189.6h0a1.532,1.532,0,0,1,1.531-1.532h0a1.533,1.533,0,1,1,0,3.065Z",
    transform: "translate(-210.847 -170.207)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon_settings.73d1ef8ad8ba54609810d0dd8935dcf9.svg";
export { ForwardRef as ReactComponent };